import React from 'react';

import { IconProps } from './types';

/**
 * The 20px bin. Used red on the owner's Delete circle and in the current colour
 * on the RSVP card's "Not going" segment — one glyph, two roles, which is why
 * the stroke is `currentColor` rather than the `#FF3B30` the Figma export
 * hardcodes.
 *
 * The paths are the export's own, in their original 16x18 space, translated
 * into a 20x20 box rather than rewritten: (20-16)/2 and (20-18)/2 centres them.
 * The export nudges the same glyph to (2.75, 1.87), which is 0.75px right and
 * 0.87px low — the kind of drift the spec says to normalise, not carry over.
 */
export const DeleteIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g transform="translate(2 1)">
          {/* lid handle */}
          <path
            d="M4.85687 2.87109C4.80153 2.57487 4.78525 2.28516 4.81455 1.99219C4.86338 1.52995 5.1889 1.14583 5.6251 0.996094C7.08343 0.501302 8.66546 0.501302 10.1238 0.996094C10.56 1.14583 10.8823 1.52995 10.9311 1.99219C10.9669 2.3112 10.9441 2.62695 10.8757 2.95573"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.25"
          />
          {/* body */}
          <path
            d="M13.1641 3.125C14.0886 6.72852 14.2774 10.472 13.724 14.1309C13.4636 15.6576 11.976 16.875 10.599 16.875C8.99097 16.875 6.7579 16.875 5.14982 16.875C3.77287 16.875 2.28524 15.6576 2.02482 14.1309C1.47144 10.472 1.66024 6.72852 2.58472 3.125"
            stroke={color}
            strokeMiterlimit="10"
            strokeWidth="1.25"
          />
          {/* lid */}
          <path
            d="M0.625092 2.50977C5.42327 3.3431 10.3289 3.33984 15.1238 2.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.25"
          />
          {/* the cross */}
          <path
            d="M5.37444 12.5C8.49944 10 10.3744 7.5 10.3744 7.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.25"
          />
          <path
            d="M10.3744 12.5C7.24944 10 5.37444 7.5 5.37444 7.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.25"
          />
        </g>
      </svg>
    );
  },
);
